export const inactiveBtn =
  'example-gallery-container__button example-gallery-container__button--disabled';
export const activeBtn = 'example-gallery-container__button';
export const activeError = 'error-message__open';
export const inactiveError = 'error-message__closed';
export const regexErrorMessage = `URL must be in the form: 'https://{env-url}/{libraryName}/app/{projectId}/{dossierId}' 
or 'https://{env-url}/{libraryName}/app/config/{configId}/{projectId}/{dossierId}'`;
export const reminderMessage = `To allow embedding your environment, you must configure CORS and SameSite Cookies settings correctly in your MicroStrategy Library Server. See instructions in `;
